import { Component, OnInit, OnDestroy } from "@angular/core";
import { JobCategoriesService } from "../services/job-categories.service";
const alertify = require("alertify.js");
import { Title } from '@angular/platform-browser';

@Component({
  selector: "ch-job-categories-listing",
  templateUrl: "./job-categories-listing.component.html",
  styleUrls: ["./job-categories-listing.component.css"],
})
export class JobCategoriesListingComponent implements OnInit, OnDestroy {
  public items = [];
  public totalItems;
  public pageParams: any = {};

  public loading: boolean;

  public breadcrumb: string[] = [];

  constructor(private jobCategoriesService: JobCategoriesService, private titleService: Title) {
    alertify.logPosition("bottom right");
  }

  ngOnInit() {
    this.titleService.setTitle(`Job Categories | CODE Hospitality CMS`);
    this.loadItems();
    this.breadcrumb = ["Job Categories"];
  }

  ngOnDestroy(): void {
    this.titleService.setTitle(`CODE Hospitality CMS`);
  }

  private loadItems() {
    this.loading = true;
    const handle = (result) => {
      const jsonData = result.json();
      this.items = jsonData;
      this.totalItems = jsonData.length;
      this.loading = false;
    };
    this.jobCategoriesService.getAllJobCategories().subscribe(handle);
  }

  public deleteJobCategory(name: string) {
    if (!confirm("Are you sure you want to delete this job category?")) {
      return;
    }
    this.loading = true;
    this.jobCategoriesService.deleteJobCategory(name).subscribe(
      (_) => {
        this.loadItems();
      },
      (err) => {
        this.loading = false;
        this.alertError(err);
      }
    );
  }

  private alertError(error: any) {
    if (!error.error) {
      alertify.error(`There was a ${error.status} error with the request.`);
    } else {
      alertify.error(
        `There was a ${error.status} error with message '${error.error}'.`
      );
    }
  }
}



// WEBPACK FOOTER //
// /Users/thxgg/Projects/Work/code-hospitality-cms/src/app/job-categories/job-categories-listing/job-categories-listing.component.ts